import { render, staticRenderFns } from "./HomeSectionFooter.vue?vue&type=template&id=1f6ab4a5&scoped=true"
import script from "./HomeSectionFooter.vue?vue&type=script&lang=js"
export * from "./HomeSectionFooter.vue?vue&type=script&lang=js"
import style0 from "./HomeSectionFooter.vue?vue&type=style&index=0&id=1f6ab4a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6ab4a5",
  null
  
)

export default component.exports